import './style/call-to-action.css';

const CallToAction = (props) => {
    return (
        <div className="ui container">
            <div className="call-to-action__con">
                <div className="call-to-action-content">
                    <h2>{props.title}</h2>
                    <p>{props.desc}</p>
                </div>
                <div className="ui button call-to-action__btn" onClick={() => props.onClick()}>{props.buttonText}</div>
            </div>
        </div>
    )
}

export default CallToAction